(function () {
  "use strict";
  // Ordinary product pages use the same existing phone-session transport.
  // The station retains its own current-customer session and cart behavior.
  if (window.HillsdaleCustomer) return;
  const KEY = 'instame_hillsdale_customer_session';
  const API = 'https://api.instame.shop';
  let memory = null, starting = null;
  function ordinary() {
    return !document.querySelector('#instame-in-store-ipad') &&
      (document.querySelector('meta[name="hillsdale-tile-proxy"]')?.dataset.shop === 'h9pw2h-fy.myshopify.com' ||
       /^(hillsdale\.lilaland\.co|h9pw2h-fy\.myshopify\.com)$/i.test(location.hostname));
  }
  function valid(value) {
    return value && typeof value.token === 'string' && value.token.length > 0 &&
      /^anon_[0-9a-f-]{36}$/i.test(value.user_id || '') &&
      /^[0-9a-f-]{36}$/i.test(value.session_id || '') &&
      typeof value.expires_at === 'number' && value.expires_at > Date.now();
  }
  function current() {
    if (!ordinary()) return null;
    if (valid(memory)) return memory;
    try { memory = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (_) { memory = null; }
    return valid(memory) ? memory : null;
  }
  function select(value) {
    memory = value;
    window.instameUserId = value.user_id;
    window.instameSessionId = value.session_id;
    try {
      sessionStorage.setItem(KEY, JSON.stringify(value));
      sessionStorage.setItem('instame_session_id', value.session_id);
    } catch (_) { /* The current page can still use its in-memory session. */ }
    return value;
  }
  async function ready() {
    if (!ordinary()) return null;
    const saved = current();
    if (saved) return select(saved);
    if (starting) return starting;
    starting = (async () => {
      const response = await fetch(API + '/api/in-store/phone-session', {method:'POST'});
      const value = await response.json().catch(() => null);
      if (!response.ok || !valid(value)) throw new Error('Could not connect. Refresh the page and try again.');
      return select(value);
    })();
    try { return await starting; } finally { starting = null; }
  }
  function headers() {
    if (window.__instameInStoreSession === true) return window.instameInStoreRequestHeaders();
    if (!ordinary()) return {};
    const value = current();
    if (!value) throw new Error('Your design session expired. Refresh the page and try again.');
    return {Authorization:'Bearer ' + value.token};
  }
  window.HillsdaleCustomer = {ready, current, headers};
})();

(function () {
  "use strict";
  const SHOP = "h9pw2h-fy.myshopify.com";
  const KEY = `lilaland:${SHOP}:visitor-session:v1`;
  const TOKEN = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\.[A-Za-z0-9_-]{43}$/;
  const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
  let uploadAttempts = new WeakMap();
  const photos = new Map(), photoReads = new Map();
  const photoLists = new Map();
  let listPermissions = new WeakMap();
  let memory = null, memoryOnly = false, sessionPromise = null, stylesPromise = null, cache = null, identityRevision = 0;
  function config() {
    const node = document.querySelector('meta[name="hillsdale-tile-proxy"]');
    const value = node?.dataset;
    if (value?.shop !== SHOP || value.visitorEnabled !== "true" ||
        !/^\/(apps|a|community|tools)\/[a-z0-9][a-z0-9_-]{0,29}$/.test(value.prefix || "") ||
        ["admin", "services", "password", "login"].includes(value.prefix.split("/")[2])) return null;
    return value;
  }
  function valid(value) {
    return value && typeof value === "object" && !Array.isArray(value) &&
      Object.keys(value).length === 2 && TOKEN.test(value.session_token) &&
      typeof value.expires_at === "string" && Date.parse(value.expires_at) > Date.now();
  }
  function clearPhotos() {
    photos.clear();
    listPermissions = new WeakMap();
    for (const read of photoLists.values()) read.controller.abort();
    photoLists.clear();
    for (const read of photoReads.values()) read.controller.abort();
    photoReads.clear();
  }
  function credential() {
    if (!config()) return null;
    try {
      const text = localStorage.getItem(KEY);
      if (text !== null) {
        let value;
        try { value = JSON.parse(text); }
        catch (_) { memory = null; cache = null; clearPhotos(); try { localStorage.removeItem(KEY); } catch (_) {} return null; }
        if (valid(value)) { if (memory && memory.session_token !== value.session_token) clearPhotos(); memory = value; memoryOnly = false; return value; }
        memory = null; cache = null; clearPhotos(); localStorage.removeItem(KEY); return null;
      }
      if (!memoryOnly) { memory = null; cache = null; clearPhotos(); return null; }
    } catch (_) { memoryOnly = true; /* Storage unavailable: retain only this page's issued identity. */ }
    if (valid(memory)) return memory;
    memory = null; cache = null; clearPhotos(); return null;
  }
  function forget(token) {
    // A late 401 from an older request must not erase a replacement identity.
    if (credential()?.session_token !== token) return;
    memory = null; cache = null; clearPhotos(); uploadAttempts = new WeakMap();
    try { localStorage.removeItem(KEY); } catch (_) {}
  }
  async function post(path, body, options = {}) {
    const controller = new AbortController(), abort = () => controller.abort();
    options.signal?.addEventListener("abort",abort,{once:true}); if (options.signal?.aborted) controller.abort();
    const timer = setTimeout(abort,options.timeout || 8000);
    try {
      const response = await fetch(path, {method:"POST",credentials:"same-origin",headers:{"Content-Type":"application/json"},
        body:JSON.stringify(body),signal:controller.signal,cache:"no-store",referrerPolicy:"no-referrer"});
      const value = response.ok ? await response.json() : null;
      if (controller.signal.aborted) throw new Error("Request cancelled.");
      return {ok:response.ok,status:response.status,value};
    } finally { clearTimeout(timer); options.signal?.removeEventListener("abort",abort); }
  }
  // Future owned-upload code calls this after user interaction. Passive style
  // reads/prewarm never create sessions, and no legacy identity is adopted.
  async function ensureSession() {
    const settings = config(); if (!settings) return null;
    const current = credential(); if (current) return current.session_token;
    if (sessionPromise) return sessionPromise;
    const revision = identityRevision;
    const task = (async () => {
      try {
        const response = await post(`${settings.prefix}/store-session`, {});
        if (!response.ok) return null;
        const value = response.value; if (!valid(value) || config()?.prefix !== settings.prefix || identityRevision !== revision) return null;
        const other = credential(); if (other) return other.session_token;
        memory = value; cache = null;
        try { localStorage.setItem(KEY, JSON.stringify(value)); memoryOnly = false; } catch (_) { memoryOnly = true; }
        return value.session_token;
      } catch (_) { return null; } // No automatic replay after an uncertain create.
    })();
    sessionPromise = task;
    try { return await task; } finally { if (sessionPromise === task) sessionPromise = null; }
  }
  function parseStyles(value) {
    if (!value || !Number.isInteger(value.expires_in) || value.expires_in < 1 || value.expires_in > 240 ||
        !value.styles || typeof value.styles !== "object" || Array.isArray(value.styles) || Object.keys(value.styles).length > 64) return null;
    const styles = Object.create(null);
    for (const [name, row] of Object.entries(value.styles)) {
      if (!/^[a-z0-9][a-z0-9_-]{0,127}$/.test(name) || !row || typeof row.image_identity !== "string" ||
          !/^[0-9a-f-]{36}$/.test(row.image_identity) || typeof row.user_upload_id !== "string" ||
          !/^[0-9a-f-]{36}$/.test(row.user_upload_id) || !Number.isFinite(Date.parse(row.created_at)) ||
          row.pet_name !== null && typeof row.pet_name !== "string") return null;
      for (const field of ["image_url","display_image_url"]) {
        let url; try { url = new URL(row[field]); } catch (_) { return null; }
        if (url.protocol !== "https:" || url.username || url.password || url.hash ||
            !url.pathname.startsWith("/storage/v1/object/sign/") || !url.searchParams.get("token")) return null;
      }
      styles[name] = {image_identity:row.image_identity,image_url:row.image_url,display_image_url:row.display_image_url,
        pet_name:row.pet_name,user_upload_id:row.user_upload_id,created_at:row.created_at};
    }
    return styles;
  }
  async function getStyles(options) {
    const settings = config(), current = credential();
    if (!settings || settings.stylesEnabled !== "true" || !current) { cache = null; return {}; }
    if (!options?.force && cache?.token === current.session_token && Date.now() < cache.expiresAt) return cache.styles;
    if (stylesPromise?.token === current.session_token) return stylesPromise.task;
    const task = (async () => {
      try {
        const response = await post(`${settings.prefix}/user/styles`, {session_token:current.session_token});
        if (response.status === 401) { forget(current.session_token); return {}; }
        if (!response.ok) { if (cache?.token === current.session_token) cache = null; return {}; }
        const value = response.value, styles = parseStyles(value);
        if (!styles || credential()?.session_token !== current.session_token || config()?.stylesEnabled !== "true" ||
            config()?.prefix !== settings.prefix) { if (cache?.token === current.session_token) cache = null; return {}; }
        cache = {token:current.session_token,styles,expiresAt:Math.min(Date.parse(current.expires_at),Date.now()+value.expires_in*1000)};
        return styles;
      } catch (_) { if (cache?.token === current.session_token) cache = null; return {}; }
    })();
    stylesPromise = {token:current.session_token,task};
    try { return await task; } finally { if (stylesPromise?.task === task) stylesPromise = null; }
  }
  function isCurrentStyle(style) {
    const current = credential(), active = cache;
    return !!(config()?.stylesEnabled === "true" && active && Date.now() < active.expiresAt &&
      current?.session_token === active.token && Object.values(active.styles).includes(style));
  }
  function clearSession() {
    identityRevision++;
    memory = null; memoryOnly = false; cache = null; clearPhotos(); uploadAttempts = new WeakMap();
    try { localStorage.removeItem(KEY); } catch (_) {}
  }
  function uploadError(code, message, requestId) {
    const error = new Error(message); error.code = code; error.userMessage = message;
    error.retryable = false; error.privateUploadError = true; if (requestId) error.requestId = requestId; return error;
  }
  function privatePhoto(value, uploadId, petName) {
    let url; try { url = new URL(value?.photo_url); } catch (_) {}
    if (!value || !UUID.test(value.upload_id) || uploadId && value.upload_id !== uploadId ||
        !Number.isInteger(value.expires_in) || value.expires_in<1 || value.expires_in>240 ||
        value.pet_name !== null && (typeof value.pet_name !== "string" || value.pet_name.length>256 || /[\u0000-\u001f\u007f]/.test(value.pet_name)) ||
        petName !== undefined && value.pet_name !== petName || !url || url.href.length>4096 || url.protocol !== "https:" || url.username || url.password || url.hash ||
        !url.pathname.startsWith("/storage/v1/object/sign/") || !url.searchParams.get("token") || [...url.searchParams.keys()].length!==1) return null;
    // The same-origin authenticated server verifies the exact private project,
    // shop/visitor path and object digest; the browser never chooses that path.
    return {upload_id:value.upload_id,photo_url:url.href,photo_path:null,pet_name:value.pet_name};
  }
  function rememberPhoto(value, token, settings, revision, expires, kind, requestId) {
    const current = credential(), expiresAt = Math.min(Date.parse(current?.expires_at),Date.now()+expires*1000);
    if (!current || current.session_token !== token || !Number.isFinite(expiresAt) || expiresAt<=Date.now()) return null;
    const photo = Object.freeze({...value,expires_at:new Date(expiresAt).toISOString(),...(requestId?{request_id:requestId}:{})});
    // Bound memory only: eviction removes permission to reuse that result.
    photos.delete(photo.upload_id);
    while (photos.size>=64) photos.delete(photos.keys().next().value);
    photos.set(photo.upload_id,{photo,token,prefix:settings.prefix,revision,expiresAt,kind});
    return photo;
  }
  function isCurrentPhoto(photo) {
    const settings = config(), current = credential(), entry = photo && photos.get(photo.upload_id);
    return !!(settings && current && entry && entry.photo===photo && entry.token===current.session_token &&
      entry.prefix===settings.prefix && entry.revision===identityRevision && Date.now()<entry.expiresAt &&
      (entry.kind==="upload" ? settings.uploadsEnabled : settings.photosEnabled)==="true");
  }
  // Passive refresh never allocates or replaces visitor identity. Caller IDs
  // are locators only; the backend verifies private ownership on every read.
  async function getPhoto(uploadId, options = {}) {
    const settings = config(), current = credential();
    if (!settings || settings.photosEnabled!=="true") throw uploadError("PRIVATE_PHOTO_PENDING","Photo access setup is pending.");
    if (typeof uploadId!=="string" || !UUID.test(uploadId)) throw uploadError("PRIVATE_PHOTO_ID","This photo could not be reopened. Please select it again.");
    if (options.signal?.aborted) throw uploadError("ABORTED","Photo request cancelled.");
    if (!current) throw uploadError("PRIVATE_SESSION_EXPIRED","Your photo session expired. Please select the photo again.");
    const cached = photos.get(uploadId);
    if (!options.force && cached && isCurrentPhoto(cached.photo)) return cached.photo;
    photos.delete(uploadId);
    let read = photoReads.get(uploadId);
    if (read && (read.token!==current.session_token || read.prefix!==settings.prefix || read.revision!==identityRevision)) {
      read.controller.abort(); photoReads.delete(uploadId); read = null;
    }
    if (!read) {
      if (photoReads.size>=16) throw uploadError("PRIVATE_PHOTO_BUSY","Please wait for your other photos to load.");
      read = {token:current.session_token,prefix:settings.prefix,revision:identityRevision,controller:new AbortController(),waiters:0};
      photoReads.set(uploadId,read);
      const active = read;
      read.task = (async () => {
        try {
          const started = Date.now(), response = await post(`${settings.prefix}/store-photo-read`,{session_token:active.token,upload_id:uploadId},{signal:active.controller.signal,timeout:30000});
          if (response.status===401) { forget(active.token); throw uploadError("PRIVATE_SESSION_EXPIRED","Your photo session expired. Please select the photo again."); }
          if (!response.ok) throw uploadError("PRIVATE_PHOTO_HELD","This photo could not be reopened. Please try again later.");
          const value = privatePhoto(response.value,uploadId);
          if (!value) throw uploadError("PRIVATE_PHOTO_RECEIPT","This photo could not be verified. Please select it again.");
          if (active.controller.signal.aborted || photoReads.get(uploadId)!==active || credential()?.session_token!==active.token ||
              identityRevision!==active.revision || config()?.photosEnabled!=="true" || config()?.prefix!==active.prefix)
            throw uploadError("PRIVATE_SESSION_CHANGED","Your photo session changed. Please select the photo again.");
          const expires = response.value.expires_in-Math.ceil((Date.now()-started)/1000);
          const result = rememberPhoto(value,active.token,settings,active.revision,expires,"read");
          if (!result) throw uploadError("PRIVATE_PHOTO_EXPIRED","This photo link expired. Please reopen the photo.");
          return result;
        } catch (error) {
          if (error.privateUploadError) throw error;
          throw uploadError("PRIVATE_PHOTO_UNAVAILABLE","This photo could not be reopened. Please try again later.");
        } finally { if (photoReads.get(uploadId)===active) photoReads.delete(uploadId); }
      })();
    }
    const active = read; active.waiters++;
    // Cancelling one caller does not cancel another caller sharing the read.
    return new Promise((resolve,reject) => {
      let settled = false;
      const finish = (error,value) => {
        if (settled) return; settled = true;
        options.signal?.removeEventListener("abort",abort); active.waiters--;
        if (!active.waiters && photoReads.get(uploadId)===active) { photoReads.delete(uploadId); active.controller.abort(); }
        if (error) reject(error); else if (!isCurrentPhoto(value)) reject(uploadError("PRIVATE_SESSION_CHANGED","Your photo session changed. Please select the photo again.")); else resolve(value);
      };
      const abort = () => finish(uploadError("ABORTED","Photo request cancelled."));
      options.signal?.addEventListener("abort",abort,{once:true}); if (options.signal?.aborted) abort();
      active.task.then(value=>finish(null,value),error=>finish(error));
    });
  }
  function isCurrentPhotoList(page) {
    const permission = page && listPermissions.get(page), settings = config(), current = credential();
    return !!(permission && settings?.listsEnabled === "true" && current?.session_token === permission.token &&
      settings.prefix === permission.prefix && identityRevision === permission.revision && Date.now() < permission.expiresAt);
  }
  // A library page carries locators only. Selecting one still requires getPhoto.
  // No automatic page traversal, cached URLs, legacy identity or session mint.
  async function listPhotos(options = {}) {
    const settings = config(), current = credential(), after = options.after;
    if (!settings || settings.listsEnabled !== "true") throw uploadError("PRIVATE_LIBRARY_PENDING","Photo library setup is pending.");
    if (after !== undefined && (typeof after !== "string" || !UUID.test(after))) throw uploadError("PRIVATE_LIBRARY_CURSOR","Please refresh your photo library.");
    if (options.signal?.aborted) throw uploadError("ABORTED","Photo request cancelled.");
    if (!current) throw uploadError("PRIVATE_SESSION_EXPIRED","Your photo session expired. Please select the photo again.");
    const key = after || "first";
    let read = photoLists.get(key);
    if (read && (read.token !== current.session_token || read.prefix !== settings.prefix || read.revision !== identityRevision)) {
      read.controller.abort(); photoLists.delete(key); read = null;
    }
    if (!read) {
      if (photoLists.size >= 8) throw uploadError("PRIVATE_LIBRARY_BUSY","Please wait for your photo library to load.");
      read = {token:current.session_token,prefix:settings.prefix,revision:identityRevision,controller:new AbortController(),waiters:0};
      photoLists.set(key,read);
      const active = read;
      read.task = (async () => {
        try {
          const started = Date.now(), response = await post(`${active.prefix}/store-photo-list`,{session_token:active.token,...(after?{after}:{})},{signal:active.controller.signal,timeout:30000});
          if (response.status === 401) { forget(active.token); throw uploadError("PRIVATE_SESSION_EXPIRED","Your photo session expired. Please select the photo again."); }
          if (!response.ok) throw uploadError("PRIVATE_LIBRARY_HELD","Your photo library could not be reopened. Please try again later.");
          const value = response.value;
          if (!value || typeof value !== "object" || Array.isArray(value) || Object.keys(value).length !== 2 ||
              !Object.hasOwn(value,"items") || !Object.hasOwn(value,"next_cursor") || !Array.isArray(value.items) || value.items.length > 20 ||
              value.next_cursor !== null && (typeof value.next_cursor !== "string" || !UUID.test(value.next_cursor) || value.items.length !== 20 || value.items.at(-1)?.upload_id !== value.next_cursor))
            throw uploadError("PRIVATE_LIBRARY_RECEIPT","Your photo library could not be verified. Please refresh it.");
          const seen = new Set(), items = value.items.map(item => {
            if (!item || typeof item !== "object" || Array.isArray(item) || Object.keys(item).length !== 2 || !Object.hasOwn(item,"pet_name") ||
                typeof item.upload_id !== "string" || !UUID.test(item.upload_id) || item.upload_id === after || seen.has(item.upload_id) ||
                item.pet_name !== null && (typeof item.pet_name !== "string" || item.pet_name.length > 256 || /[\u0000-\u001f\u007f]/.test(item.pet_name)))
              throw uploadError("PRIVATE_LIBRARY_RECEIPT","Your photo library could not be verified. Please refresh it.");
            seen.add(item.upload_id); return Object.freeze({upload_id:item.upload_id,pet_name:item.pet_name});
          });
          if (active.controller.signal.aborted || photoLists.get(key) !== active || credential()?.session_token !== active.token ||
              identityRevision !== active.revision || config()?.listsEnabled !== "true" || config()?.prefix !== active.prefix)
            throw uploadError("PRIVATE_SESSION_CHANGED","Your photo session changed. Please refresh your photo library.");
          const expiresAt = Math.min(Date.parse(current.expires_at),started+30000);
          if (Date.now() >= expiresAt) throw uploadError("PRIVATE_LIBRARY_EXPIRED","Please refresh your photo library.");
          const page = Object.freeze({items:Object.freeze(items),next_cursor:value.next_cursor});
          listPermissions.set(page,{token:active.token,prefix:active.prefix,revision:active.revision,expiresAt});
          return page;
        } catch (error) {
          if (error.privateUploadError) throw error;
          throw uploadError("PRIVATE_LIBRARY_UNAVAILABLE","Your photo library could not be reopened. Please try again later.");
        } finally { if (photoLists.get(key) === active) photoLists.delete(key); }
      })();
    }
    const active = read; active.waiters++;
    return new Promise((resolve,reject) => {
      let settled = false;
      const finish = (error,page) => {
        if (settled) return; settled = true;
        options.signal?.removeEventListener("abort",abort); active.waiters--;
        if (!active.waiters && photoLists.get(key) === active) { photoLists.delete(key); active.controller.abort(); }
        if (error) reject(error); else if (!isCurrentPhotoList(page)) reject(uploadError("PRIVATE_SESSION_CHANGED","Your photo session changed. Please refresh your photo library.")); else resolve(page);
      };
      const abort = () => finish(uploadError("ABORTED","Photo request cancelled."));
      options.signal?.addEventListener("abort",abort,{once:true}); if (options.signal?.aborted) abort();
      active.task.then(page=>finish(null,page),error=>finish(error));
    });
  }
  async function uploadPhoto(file, options = {}) {
    const settings = config();
    if (!settings || settings.uploadsEnabled !== "true") throw uploadError("PRIVATE_UPLOAD_PENDING", "Photo upload setup is pending.");
    if (!(file instanceof Blob) || !file.size || file.size > 10*1024*1024 ||
        options.petName != null && (typeof options.petName !== "string" || options.petName.length > 256 || /[\u0000-\u001f\u007f]/.test(options.petName)) ||
        options.requestId !== undefined && !UUID.test(options.requestId)) throw uploadError("INVALID_PHOTO", "Please select a supported photo and try again.");
    if (options.signal?.aborted) throw uploadError("ABORTED", "Upload cancelled.");
    const token = await ensureSession();
    if (!token || options.signal?.aborted) throw uploadError(options.signal?.aborted ? "ABORTED" : "PRIVATE_SESSION_PENDING", options.signal?.aborted ? "Upload cancelled." : "Your photo session could not be started. Please try again.");
    const petName = options.petName || null, old = uploadAttempts.get(file);
    let attempt = old;
    if (!attempt || attempt.token !== token || attempt.petName !== petName || attempt.prefix !== settings.prefix ||
        options.requestId && attempt.requestId !== options.requestId) {
      attempt = {token,petName,prefix:settings.prefix,requestId:options.requestId || crypto.randomUUID(),promise:null};
      uploadAttempts.set(file, attempt);
    }
    if (attempt.promise) return attempt.promise;
    const requestId = attempt.requestId, revision = identityRevision;
    const task = (async () => {
      for (let index=0; index<3; index++) {
        if (options.signal?.aborted) throw uploadError("ABORTED","Upload cancelled.",requestId);
        const current = credential();
        if (!current || current.session_token !== token || identityRevision !== revision || config()?.uploadsEnabled !== "true" || config()?.prefix !== settings.prefix)
          throw uploadError("PRIVATE_SESSION_CHANGED", "Your photo session changed. Please select the photo again.", requestId);
        const controller = new AbortController(), abort = () => controller.abort();
        options.signal?.addEventListener("abort",abort,{once:true});
        if (options.signal?.aborted) controller.abort();
        const timer = setTimeout(abort,60000);
        let response;
        try {
          const form = new FormData(); form.append("session_token",token); form.append("request_id",requestId);
          form.append("file",file,"photo"); if (petName !== null) form.append("pet_name",petName);
          const started = Date.now();
          response = await fetch(`${settings.prefix}/store-photo-upload`, {method:"POST",credentials:"same-origin",body:form,
            signal:controller.signal,cache:"no-store",referrerPolicy:"no-referrer"});
          if (response.status === 401) { forget(token); throw uploadError("PRIVATE_SESSION_EXPIRED", "Your photo session expired. Please select the photo again.",requestId); }
          if (response.ok) {
            const value = await response.json(), photo = privatePhoto(value,attempt.uploadId,petName);
            if (!photo)
              throw uploadError("PRIVATE_UPLOAD_RECEIPT", "The photo upload could not be verified. Please try again later.",requestId);
            if (credential()?.session_token !== token || identityRevision !== revision || config()?.uploadsEnabled !== "true" || config()?.prefix !== settings.prefix)
              throw uploadError("PRIVATE_SESSION_CHANGED", "Your photo session changed. Please select the photo again.",requestId);
            if (options.signal?.aborted) throw uploadError("ABORTED","Upload cancelled.",requestId);
            attempt.uploadId = value.upload_id;
            const expires = value.expires_in-Math.ceil((Date.now()-started)/1000);
            const result = rememberPhoto(photo,token,settings,revision,expires,"upload",requestId);
            if (!result) throw uploadError("PRIVATE_PHOTO_EXPIRED","The photo needs a fresh link. Please try again later.",requestId);
            return result;
          }
          if (![408,429].includes(response.status) && response.status<500)
            throw uploadError(response.status===409 ? "PRIVATE_UPLOAD_HELD" : "PRIVATE_UPLOAD_REJECTED",
              response.status===409 ? "This photo upload needs review. Please try again later." : "Please select a supported photo and try again.",requestId);
        } catch (error) {
          if (error.privateUploadError) throw error;
          if (options.signal?.aborted) throw uploadError("ABORTED","Upload cancelled.",requestId);
          if (index===2) throw uploadError("PRIVATE_UPLOAD_UNCERTAIN","The photo upload could not be confirmed. Please try again later.",requestId);
        } finally { clearTimeout(timer); options.signal?.removeEventListener("abort",abort); }
        if (index===2) throw uploadError("PRIVATE_UPLOAD_UNCERTAIN","The photo upload could not be confirmed. Please try again later.",requestId);
        await new Promise(resolve=>setTimeout(resolve,index===0?1000:2000));
      }
    })();
    attempt.promise = task;
    try { return await task; } finally { if (attempt.promise===task) attempt.promise=null; }
  }
  // No visitor ID, legacy-ID bridge, cookie, marketing call or bearer query URL.
  window.HillsdaleVisitor = Object.freeze({ensureSession,getStyles,isCurrentStyle,clearSession,uploadPhoto,getPhoto,isCurrentPhoto,listPhotos,isCurrentPhotoList});
})();
